module.exports = __webpack_public_path__ + "static/media/5.eb8a9c8c.jpg";